import { api } from 'shared/api'
import { AiConversationFeedbackSchemasNew } from 'shared/api/requests/aiConversationFeedback/newSchemas'

export const AiConversationFeedbackApiNew = {
  save: api.account.createPost({
    url: '/ai-service/conversation-feedback',
    schemas: AiConversationFeedbackSchemasNew.save,
    scope: 'ai',
    section: 'ai_always_on_automation',
  }),
  retrieve: api.account.createGet({
    url: '/ai-service/conversation-feedback',
    schemas: AiConversationFeedbackSchemasNew.retrieve,
    scope: 'ai',
    section: 'ai_always_on_automation',
  }),
}
